/* eslint no-underscore-dangle: 0 */

import React, { useState, useEffect } from 'react'
import moment from 'moment'
import _ from 'lodash'
import { Menu, MenuItem } from '@material-ui/core'
import { StyledButton } from '../../../../../theme/Global'
import { CustomArrowDropDown } from './styles'
import { formatDate } from '../../../../../common/helpers'
import DatePicker from '../../../datePicker'
import { Modal } from '../../../../../common/components/modal'

const DateFilter = ({
  isLoading,
  maxDropDownHeight,
  eventHandlers,
  filterOptions
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [filterDateLabel, setFilterDateLabel] = useState('')

  useEffect(() => {
    let subscribed = true
    if (filterOptions.date) {
      const dayCount = moment(filterOptions.date.endDate).diff(moment(filterOptions.date.startDate), 'days')
      switch (dayCount) {
        case 30:
        case 60:
        case 90:
          setFilterDateLabel(`${dayCount} Days`)
          break
        case 364:
          setFilterDateLabel('This Year')
          break
        case 1826:
          setFilterDateLabel('5 Years')
          break
        default:
          setFilterDateLabel(`${filterOptions.date.startDate} - ${filterOptions.date.endDate}`)
      }
    }
    return () => { subscribed = false }
  }, [])

  const openFilterDateMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const setCustomDateRange = (startDate, endDate) => {
    setModalOpen(false)
    const range = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    }
    eventHandlers.setFilterOptions({ ...filterOptions, date: range })
    setFilterDateLabel(`${range.startDate} - ${range.endDate}`)
  }

  const filter = Object.freeze({
    options: [
      { value: '30', startDate: formatDate(), endDate: formatDate(moment().add(30, 'days')), label: '30 days' },
      { value: '60', startDate: formatDate(), endDate: formatDate(moment().add(60, 'days')), label: '60 days' },
      { value: '90', startDate: formatDate(), endDate: formatDate(moment().add(90, 'days')), label: '90 days' },
      { value: 'thisYear', startDate: formatDate(`${moment().format('YYYY')}-01-01`), endDate: formatDate(`${moment().format('YYYY')}-12-31`), label: 'This Year' },
      { value: '5year', startDate: formatDate(), endDate: formatDate(moment().add(5, 'years')), label: '5 Years' }
    ]
  })

  const closeFilterDateMenu = (value) => {
    setAnchorEl(null)
    const selectedOption = filter.options.find((option) => option.value === value)

    if (value === 'custom') {
      setModalOpen(true)
    } else {
      if (selectedOption === undefined) {
        return
      }

      const range = {
        startDate: selectedOption.startDate,
        endDate: selectedOption.endDate
      }

      if (_.isEqual(range, filterOptions.date)) {
        return
      }

      eventHandlers.setFilterOptions({ ...filterOptions, date: range })
      setFilterDateLabel(selectedOption.label)
    }
  }

  return (
    <div>
      <StyledButton onClick={openFilterDateMenu} disabled={isLoading} data-testid="date-filter-button">
        {`Range: ${filterDateLabel}`}
        {CustomArrowDropDown}
      </StyledButton>
      <Menu
        data-testid="date-filter-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={closeFilterDateMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        getContentAnchorEl={null}
        MenuListProps={{ style: { maxHeight: maxDropDownHeight } }}
      >
        <MenuItem disabled={filterDateLabel === '30 days'} selected={filterDateLabel === '30 days'} data-testid="date-filter-option-30" onClick={() => closeFilterDateMenu('30')}>30 days</MenuItem>
        <MenuItem disabled={filterDateLabel === '60 days'} selected={filterDateLabel === '60 days'} data-testid="date-filter-option-60" onClick={() => closeFilterDateMenu('60')}>60 days</MenuItem>
        <MenuItem disabled={filterDateLabel === '90 days'} selected={filterDateLabel === '90 days'} data-testid="date-filter-option-90" onClick={() => closeFilterDateMenu('90')}>90 days</MenuItem>
        <MenuItem disabled={filterDateLabel === 'This Year'} selected={filterDateLabel === 'This Year'} data-testid="date-filter-option-year" onClick={() => closeFilterDateMenu('thisYear')}>
          This Year
        </MenuItem>
        <MenuItem disabled={filterDateLabel === '5 Years'} selected={filterDateLabel === '5 Years'} data-testid="date-filter-option-5year" onClick={() => closeFilterDateMenu('5year')}>5 Years</MenuItem>
        <MenuItem selected={filterDateLabel === `${filterOptions.date.startDate} - ${filterOptions.date.endDate}`} data-testid="date-filter-option-custom" onClick={() => closeFilterDateMenu('custom')}>
          Custom Date Range
        </MenuItem>
      </Menu>
      <Modal
        data-testid="date-filter-custom-modal"
        open={modalOpen}
        title="Custom Date Range"
        component={(
          <DatePicker
            startDate={filterOptions.date ? filterOptions.date.startDate : null}
            endDate={filterOptions.date ? filterOptions.date.endDate : null}
            onSelect={setCustomDateRange}
          />
            )}
        modalCloseDispatch={() => {
          setModalOpen(false)
        }}
        isFullWidth
        maxWidth="sm"
        unsetHeight
      />
    </div>
  )
}

export default DateFilter
